import { CSVLink } from "react-csv";
import axios from 'axios'
import settings from "../config/settings";
import React, {useState,useEffect,useRef, useContext, useCallback} from "react"
import { timeDimensionMapper } from './Reusables'
import _ from 'lodash';
import moment from 'moment'
import { decode } from 'html-entities';
import { CubeContext } from "@cubejs-client/react";
import toast from "react-hot-toast";





const ExportReactCSV = ({reportDetails,setExportCsv,columnDisplayName,columnTitle }) => {

  const [csvHeader,setCsvHeader] = useState([]);
  const [csvData,setCsvData] = useState([])
  const [measureTitle, setMeasureTitle] = useState({})
  const [dimensionTitle, setDimensionTitle] = useState({})
  const csvRef = useRef()
  const cubejsApi = useContext(CubeContext).cubejsApi

  const  {CUBE_API_URL } = settings

  const formatReportTitle = (data) => {
    let dimensionTitle = {};
    let measureTitle = {};

    data?.dimensions?.map(dim => {
      let key = dim?.fieldName;
      dimensionTitle[key] = dim?.title
    })
    data?.measures?.map(meas => {
      let key = meas?.fieldName;
      measureTitle[key] = meas?.title
    });

    setMeasureTitle(measureTitle)
    setDimensionTitle(dimensionTitle)
  }

  const mapResponseForQuery = useCallback((reportDetailsQuery) => {
    let tempQuery = { vizState: {} }
    tempQuery.name = reportDetailsQuery?.reportName
    const dateFormat = handleDateFormatField(reportDetailsQuery?.dimensions)
    const colDisplayName = handleColumnDisplayName(reportDetailsQuery)
    const fieldFormat = handleMeasureFieldFormat(reportDetailsQuery?.measures)
    const reportFilters = handleReportFilters(reportDetailsQuery?.reportFilters)
    tempQuery.report = reportDetailsQuery

    tempQuery.vizState = {
      chartType: reportDetailsQuery?.chartType,
      query: {
        measures: handleReportFields(reportDetailsQuery?.measures),
        order: handleQueryOrderBy(reportDetailsQuery?.orderBy),
        dimensions: handleReportFields(reportDetailsQuery?.dimensions),
        limit: reportDetailsQuery?.limit,
        timezone: 'UTC',
        filters: handleFilterNullValues(reportFilters),
        renewQuery: reportDetailsQuery?.renewQuery,
        timeDimensions: reportDetailsQuery?.timeDimensions,
      },
      pivotConfig: handlePivotConfigFormat(reportDetailsQuery?.pivotConfig),
      columnState: reportDetailsQuery?.columnState,
      orderBy:reportDetailsQuery?.orderBy,
      isPivotEnabled: reportDetailsQuery?.isPivotEnabled,
      isLegendVisible: reportDetailsQuery?.isLegendVisible,
      legendPosition: reportDetailsQuery?.legendPosition,
      columnTitle: [{ ...dimensionTitle, ...measureTitle }],
      dateFieldFormat: dateFormat,
      columnDisplayName: colDisplayName,
      fieldFormat: fieldFormat,
      noDataText: reportDetailsQuery?.noDataText,
      reportHyperlink: reportDetailsQuery?.reportHyperlink || [],
      settings: reportDetailsQuery?.settings,
      rateChangeQuery: handleRateChangeQuery(reportDetailsQuery),
      toggleToTable: reportDetailsQuery?.toggleToTable,
      viewMode: 'report',
      reportName: reportDetailsQuery?.reportName,
      description: reportDetailsQuery?.description,
      fieldsKeyInfo: getReportFieldsKey(),
      hiddenFields: getHiddenFields([...reportDetailsQuery?.measures, ...reportDetailsQuery?.dimensions]),
      comparisonChartType: reportDetailsQuery?.comparisonChartType,
    }
    tempQuery.vizState.query.filters = tempQuery.vizState.query.filters?.map((item) => {
      if (item.operator === 'set' || item.operator === 'notSet') {
        return { member: item.member, operator: item.operator }
      }
      if (item?.member && item?.operator && item?.values?.length > 0)
        return { member: item.member, operator: item.operator, values: item.values }
    })
    return tempQuery
  })

  const handleDateFormatField = (dimensions) => {
    let dateFormat = {};
    dimensions?.map(dim => {
      if (dim?.dateFormat) {
        dateFormat[dim?.fieldName + '_date'] = dim?.dateFormat
      }
      else if (dim?.timeFormat) {
        dateFormat[dim?.fieldName + `_${dim?.timeFormatType}`] = dim?.timeFormat
      }
    })
    return dateFormat;
  }

  const handleColumnDisplayName = (report) => {
    const measures = report?.measures;
    const dimensions = report?.dimensions;
    const timeDimensions = report?.timeDimensions
    const displayObj = {};

    if (measures && measures.length) {
      measures.forEach(ele => {
        const { fieldName, displayName } = ele;
        if (displayName) {
          displayObj[fieldName] = displayName;
        }
      })
    }
    if (dimensions && dimensions.length) {
      dimensions.forEach(ele => {
        const { fieldName, displayName } = ele;
        if (displayName) {
          displayObj[fieldName] = displayName;
        }
      })
    }

    if (timeDimensions && timeDimensions.length) {
      timeDimensions.forEach(ele => {
        const { dimension, displayTitle, displayName } = ele;
        if (displayName) {
          displayObj[dimension] = displayTitle ? displayTitle : displayName ? displayName : dimension
        }
      })
    }
    return displayObj;
  }

  const handleMeasureFieldFormat = (measures) => {
    const formatObj = {}
    if (measures && measures.length) {
      measures.forEach(ele => {
        const { fieldName, fieldFormat } = ele;
        if (fieldFormat) {
          formatObj[fieldName] = fieldFormat;
        }
      })
    }
    return formatObj;
  }

  const handleReportFilters = (filters) => {
    if (filters.length) {
      return filters.map(f => {
        if (f?.operator === "top" || f?.operator === "bottom") {
          f = { ...f, operator: "equals" }
        }
        return f;
      })
    }
    else {
      return filters
    }
  }

  const handleReportFields = (reportFields) => {
    let fieldsArr = []
    if (reportFields.length) {
      for (let fields of reportFields) {
        // if (!fields?.isHidden) {
        fieldsArr.push(fields?.fieldName)
        // }
      }
    }
    return fieldsArr;
  }

  const handleFilterNullValues = (reportFilters) => {
    return reportFilters?.filter((item) => {
      if ((item.operator === 'set' || item.operator === 'notSet') ||
        (item?.values?.length > 0 && (!item?.values.includes(null) && !item?.values?.includes("")))) {
        return item
      }
    })?.map(f => {
      if (f.operator === 'set' || f.operator === 'notSet') {
        return {
          member: f?.member, operator: f?.operator
        }
      } else {
        return {
          member: f?.member, operator: f?.operator, values: f?.values
        }
      }
    })
  }

  const handlePivotConfigFormat = (pivot) => {
    let xArr = pivot?.xAxis?.list.map(ele => ele.text)
    let yArr = []

    if (pivot?.group?.list) {
      yArr = [...pivot?.group?.list.map(ele => ele?.text), ...pivot?.value?.list.map(ele => ele?.text)]
    }
    else {
      yArr = [...pivot?.value?.list.map(ele => ele?.text)]
    }

    let lines = pivot?.lines?.list
    let group = pivot?.group?.list

    const config = {
      x: xArr,
      y: yArr,
      lines,
      group,
    }

    return config
  }

  const getReportFieldsKey = () => {
    let info = { measureKey: [], dimensionKey: [] }
    if (reportDetails?.reportDetails?.measures.length) {
      info.measureKey = reportDetails?.reportDetails?.measures.map(meas => meas?.fieldName)
    }
    if (reportDetails?.reportDetails?.dimensions.length) {
      info.dimensionKey = reportDetails?.reportDetails?.dimensions.map(dim => dim?.fieldName)
    }
    return info
  }

  const handleQueryOrderBy = (order) => {
    let orderBy = {};
    order?.forEach(ele => {
      orderBy[ele?.content?.key] = ele?.content?.order;
    })
    return orderBy;
  }

  const handleRateChangeQuery = (reportDetailsQuery) => {
      if ((reportDetailsQuery?.settings?.rateChangeProps?.periodicity || reportDetailsQuery?.settings?.rateChangeProps?.customVal)
        && (reportDetailsQuery?.timeDimensions?.length || reportDetailsQuery?.settings?.rateChangeProps?.dateField)) {
        const reportFilters = handleReportFilters(reportDetailsQuery?.reportFilters)
        const { periodicity, customVal } = reportDetailsQuery?.settings?.rateChangeProps
        let granularityDimension = reportDetailsQuery?.settings?.rateChangeProps?.dateField || reportDetailsQuery?.timeDimensions[0]?.dimension;
  
        const queryProps = { chartType: reportDetailsQuery?.chartType, settings: reportDetailsQuery?.settings, query: [] }
        for (let i = 0; i < 2; i++) {
          let query = {
            measures: handleReportFields(reportDetailsQuery?.measures),
            order: handleQueryOrderBy(reportDetailsQuery?.orderBy),
            dimensions: handleReportFields(reportDetailsQuery?.dimensions),
            limit: reportDetailsQuery?.limit,
            timezone: 'UTC',
            timeDimensions: reportDetailsQuery?.timeDimensions,
            filters: handleFilterNullValues(reportFilters),
            renewQuery: reportDetailsQuery?.renewQuery
          }
  
          if (periodicity && !customVal) {
            switch (periodicity) {
              case 'daily':
                if (i === 0) {
                  query.timeDimensions = [{ "dimension": granularityDimension, "dateRange": "Yesterday", "granularity": "day" }]
                }
                else {
                  query.timeDimensions = [{ "dimension": granularityDimension, "dateRange": "Today", "granularity": "day" }]
                }
                break;
              case 'weekly':
                if (i === 0) {
                  query.timeDimensions = [{ "dimension": granularityDimension, "dateRange": "Last Week", "granularity": "week" }]
                }
                else {
                  query.timeDimensions = [{ "dimension": granularityDimension, "dateRange": "This Week", "granularity": "week" }]
                }
                break;
              case 'monthly':
                if (i === 0) {
                  query.timeDimensions = [{ "dimension": granularityDimension, "dateRange": "Last Month", "granularity": "month" }]
                }
                else {
                  query.timeDimensions = [{ "dimension": granularityDimension, "dateRange": "This Month", "granularity": "month" }]
                }
                break;
  
              case 'quarterly':
                if (i === 0) {
                  query.timeDimensions = [{ "dimension": granularityDimension, "dateRange": "Last Quarter", "granularity": "quarter" }]
  
                }
                else {
                  query.timeDimensions = [{ "dimension": granularityDimension, "dateRange": "This Quarter", "granularity": "quarter" }]
                }
                break;
              case 'yearly':
                if (i === 0) {
                  query.timeDimensions = [{ "dimension": granularityDimension, "dateRange": "Last Year", "granularity": "year" }]
                }
                else {
                  query.timeDimensions = [{ "dimension": granularityDimension, "dateRange": "This Year", "granularity": "year" }]
                }
                break;
              default:
                return
            }
          }
          else {
            let customVal = reportDetailsQuery?.settings?.rateChangeProps?.customVal
            customVal = parseInt(customVal)
            let granularity;
            if (customVal === 1) {
              granularity = 'day';
            }
            else if (customVal > 1 && customVal < 7) {
              granularity = 'weeek';
            }
            else if (customVal >= 7 && customVal < 30) {
              granularity = 'month';
            }
            else if (customVal >= 30 && customVal < 120) {
              granularity = 'quarter';
            }
            else {
              granularity = 'year';
            }
  
            let currEndDate = moment().format("YYYY/MM/DD");
            let currentStartDate = moment().subtract((customVal - 1), "days").format("YYYY/MM/DD");
            let prevEndDate = moment().subtract(customVal, "days").format("YYYY/MM/DD");
            let prevStartDate = moment().subtract(customVal, "days").subtract(customVal - 1, "days").format("YYYY/MM/DD");
  
            const startDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
  
            if (new Date(prevStartDate) < startDate) {
              granularity = 'year'
            }
            else {
              granularity = 'month'
            }
  
            if (i === 0) {
              query.timeDimensions = [{ "dimension": granularityDimension, "dateRange": [prevStartDate, prevEndDate], "granularity": granularity }]
            }
            else {
              query.timeDimensions = [{ "dimension": granularityDimension, "dateRange": [currentStartDate, currEndDate], "granularity": granularity }]
            }
          }
          queryProps.query.push(query)
        }
  
        return queryProps
      }
      return null
  }

  const getHiddenFields = (fields) => {
    let fieldsArr = []
    if (fields.length) {
      for (let field of fields) {
        if (field?.isHidden) {
          fieldsArr.push(field?.fieldName)
        }
      }
    }
    return fieldsArr;
  }

const getCubeData = async (payload) => {
  const query = payload.query
  query.limit = 20000
  query.total = true
  const dataLimit = 1000000
  //query.offset = 
  //var instance = axios.create();
  //delete instance.defaults.headers.common['accessToken'];
  let resData = []
  try{
    let res = await getCubeDataRaw(query)
    resData = [...resData,...res.data]
    if(resData.length  === res.total){
      return await (() => {return {query,data:resData}})()
    }else{
      let pages = Math.ceil(res.total/query.limit)
      //console.log('Total Pages',pages)
      return await (async () => {
        for(let i=1; i<pages;i++){
          query.offset = query.limit * i
          let res = await getCubeDataRaw(query)
          resData = [...resData,...res.data]
          if(resData.length >= dataLimit){
            break;
          }
        }
        return {query,data:resData}
      })()     
    }
    //return {query,data:data.rawData()}
  }catch(e){
    console.log(e)
    return null
  }
  
  //console.log(data)
} 

const getCubeDataRaw = async (query) => {
  try{
    let data = await cubejsApi.load(query)
    const total = data.loadResponse.results[0].total
    return {total,data:data.rawData()}
    //console.log(data)
  }catch(e){
    return []
  }
}

  useEffect(() => {
    formatReportTitle(reportDetails?.reportDetails)
    transformData()
  },[])

  const transformData = async () => {
    if(reportDetails?.reportDetails) {
        const reportDetailsData = mapResponseForQuery(reportDetails?.reportDetails);
        const reportQuery = timeDimensionMapper(reportDetailsData?.vizState?.query)
        const data = await getCubeData({query:reportQuery})
        //console.log('CSV Data',data)

        if(data && data?.data.length > 0) {
            const { timeDimensions } = data?.query
            const modifiedData = handleTimeDimensionFormat({data:data?.data,timeDimensions,reportDetails: reportDetailsData})
            //console.log(modifiedData)
            transformCsvData(modifiedData)
        }else{
          toast.dismiss()
          toast.error('No data available for export')
          setExportCsv(false)
        }
    }
  }
  
  const formatNumberTimeField = (value, format, type) => {
  let strHr, hours, minutes, seconds;

  if (type === 'second') {
    const sec = parseInt(value, 10);
    hours = Math.floor(sec / 3600);
    minutes = Math.floor((sec - (hours * 3600)) / 60);
    seconds = sec - (hours * 3600) - (minutes * 60);
    if (hours < 10) {
      if (hours) {
        strHr = "0" + hours;
      }
      hours = "0" + hours;
    }
    else {
      strHr = hours
    }
    if (minutes < 10) { minutes = "0" + minutes; }
    if (seconds < 10) { seconds = "0" + seconds; }
  }
  else if (type === 'minute') {
    const min = parseFloat(value, 10);
    hours = Math.floor(min / 60);
    minutes = Math.floor((min - ((hours * 3600)) / 60));
    seconds = Math.floor((min * 60) - (hours * 3600) - (minutes * 60));

    if (hours < 10) {
      if (hours) {
        strHr = "0" + hours;
      }
      hours = "0" + hours;
    }
    else {
      strHr = hours
    }

    if (minutes < 10) { minutes = "0" + minutes; }
    if (seconds < 10) { seconds = "0" + seconds; }
  }
  else if (type === 'hour') {
    const hr = parseFloat(value, 10);
    hours = Math.floor(hr);
    minutes = (Math.abs(hr) - hours) * 60
    seconds = (Math.abs(minutes) - Math.floor(minutes)) * 60

    if (hours < 10) {
      if (hours) {
        strHr = "0" + hours;
      }
      hours = "0" + hours;
    }
    else {
      strHr = hours
    }
    if (minutes < 10) { minutes = "0" + minutes; }
    if (seconds < 10) { seconds = "0" + seconds; }
  }

  let formatted;

  switch (format) {
    case 'hh:mm:ss':
      formatted = hours + ':' + minutes + ':' + seconds;
      break;
    case 'HH:MM:SS':
      if (strHr) {
        formatted = `${hours}hour : ${minutes}minute : ${seconds}second`
      }
      else {
        formatted = `${minutes}minute : ${seconds}second`
      }
      break;
    default:
      formatted = value
      break;
  }
  return formatted;
}


const handleTimeDimensionFormat = ({data,timeDimensions,reportDetails}) => {
    let TimeGranularityKey = null
    let GranularityDateFormat = ''
    const {timeDimensionDateFormat,dateFieldFormat,fieldFormat } = reportDetails?.vizState

    if (timeDimensions && timeDimensions.length) {
      let { dimension, granularity } = timeDimensions[0]
      TimeGranularityKey = `${dimension ?? ''}.${granularity ?? ''}`

      let dateFormat = 'DD MMM YY'

      switch (granularity) {
        case 'hour':
          dateFormat = dateFormat + " HH"
          break;
        case 'minute':
          dateFormat = dateFormat + " HH:mm"
          break;
        case 'second':
          dateFormat = dateFormat + " HH:mm:ss"
          break;
        case 'month':
          dateFormat = "MMM YY"
          break;
        case 'year':
          dateFormat = "YYYY"
          break;
        default:
          break
      }
      GranularityDateFormat = dateFormat
    }
    let rowsCount = 1
    for (let pivot of data) {
      // pivot['serialNo'] = rowsCount
      rowsCount++
      if(timeDimensionDateFormat && Object.values(timeDimensionDateFormat)?.length) {
        for(let f of Object?.values(timeDimensionDateFormat)) {
          let {format,key,granularity} = f
          let granKey = key+'.'+granularity
          if(pivot[granKey] && format) {
             pivot[granKey] = moment(pivot[granKey]).format(format)
          }
          else if(pivot[TimeGranularityKey] && GranularityDateFormat) {
             pivot[TimeGranularityKey] = moment(pivot[TimeGranularityKey]).format(GranularityDateFormat)    
          }
        }
      }
      else if(pivot[TimeGranularityKey] && GranularityDateFormat) {
        pivot[TimeGranularityKey] = moment(pivot[TimeGranularityKey]).format(GranularityDateFormat)
      }
      if (dateFieldFormat && Object.keys(dateFieldFormat).length) {
        for (let obj of Object.keys(dateFieldFormat)) {
          let [field, type] = obj.split('_')
          if (type === 'date' && pivot[field]) {
            pivot[field] = moment(pivot[field]).format(dateFieldFormat[obj])
          }
          else if (pivot[field]) {
            const formatted = formatNumberTimeField(pivot[field], dateFieldFormat[obj], type);
            pivot[field] = formatted
          }

        }
      }

      if (fieldFormat && Object.keys(fieldFormat).length) {
        for (let obj of Object.keys(fieldFormat)) {
          if (pivot[obj] && fieldFormat[obj] === 'percent') {
            pivot[obj] = pivot[obj] + '%'
          }
        }
      }
      for (let key of Object.keys(pivot)) {
        if (pivot[key] === undefined || pivot[key] === null || pivot[key] === 'NaN') {
          pivot[key] = 'NA'
        }
        if (pivot[key]) {
          pivot[key] = decode(pivot[key])
        }
      }
    }
    return data
}


  const handleChartLabel = (key) => {
    let label;
    let columnLabel = { ...columnDisplayName }
    if (columnTitle && columnTitle.length && Object.keys(columnTitle[0]).length) {
        for (let title of Object.keys(columnTitle[0])) {
            if (columnTitle[0][title]) {
                columnLabel[title] = columnTitle[0][title]
            }
        }
    }

    if (key && columnLabel && Object.keys(columnLabel).length && columnLabel[key]) {
        label = columnLabel[key]
        if (Object.keys(columnLabel).length === 1) {
            if (columnLabel[key].trim() === '') {
                label = label.replace(',', '')
            }
        }
        else {
            for (let index = 0; index < Object.keys(columnLabel).length; index++) {
                if (index !== 0) {
                    if (key === Object.keys(columnLabel)[index] && columnLabel[Object.keys(columnLabel)[index - 1]].trim() === '') {
                        label = columnLabel[key].replace(',', '')
                    }
                }
            }
        }
    }
    else if (key && columnLabel && Object.keys(columnLabel).length) {
        for (let col of Object.keys(columnLabel)) {
            if (key.includes(col)) {
                let temp = key;
                if (columnLabel[col].trim() === '') {
                    key = key.replace(`,${col}`, columnLabel[col]);
                    if (temp === key) {
                        key = key.replace(col, columnLabel[col]);
                    }
                }
                else {
                    key = key.replace(col, columnLabel[col]);
                }
                label = key;
            }
        }
    }
    else {
        label = _.startCase(key?.split('.')[1])
    }
    return label;
}


  const transformCsvData = (data) => {

    const orderedColumns = [];
    const hiddenColumns = new Set();


      // Add columns from groupBySettings to hidden columns
  reportDetails?.reportDetails?.settings?.groupBySettings?.forEach(group => {
  
      if (group.concatWith && Array.isArray(group.concatWith)) {
        group.concatWith.forEach(field => {
        hiddenColumns.add(field); 
      });
    }
  });
     // Get hidden columns from dimensions
    reportDetails?.reportDetails?.dimensions?.forEach(dim => {
      if (dim.isHidden) {
        hiddenColumns.add(dim.fieldName);
      }
    });


    // Get ordered columns from dimensions while excluding hidden ones
    reportDetails?.reportDetails?.pivotConfig?.xAxis?.list?.forEach(item => {
      if(!hiddenColumns.has(item.text)) {
      orderedColumns.push(item.text);
      }
    });
       // Add measures to ordered columns
    reportDetails?.reportDetails?.measures?.forEach(measure => {
      if(!hiddenColumns.has(measure.fieldName)) {
      orderedColumns.push(measure.fieldName);
      }
    });


    const headers = orderedColumns.map(columnName => ({
      label: handleChartLabel(columnName) || _.startCase(columnName?.split('.')[1]),
      key: columnName
    }));

    const orderedData = data.map(row => {
      const newRow = {};
      headers.forEach(({key}) => {
        if (!hiddenColumns.has(key)) {
          newRow[key] = row[key];
        }
      });
      return newRow;
    });
  
    setCsvHeader(headers);
    setCsvData(orderedData);
    
    if(csvRef && csvRef.current) {
      csvRef?.current?.link?.click();
    }      
    setExportCsv(false);
  };

 return <CSVLink
    headers={csvHeader}
    data={csvData}
    filename={reportDetails?.reportDetails?.reportName ? reportDetails?.reportDetails?.reportName+'.csv' : 'test.csv'}
    ref={csvRef}
  />


  
};

export default ExportReactCSV;
